import type { bloomreachEventsConfig } from '@/shared/lib';

export type EventsState = Record<
  bloomreachEventsConfig.BloomreachEventName,
  unknown
>;

/**
 * Link below for full description
 * @see https://documentation.bloomreach.com/engagement/docs/integration
 * */
type Config = {
  target?: string;
  token?: string;
  file_path?: string;
  ping?: {
    activity: object | boolean;
  };
};

export type MappedCustomerIDs = {
  user_id: string;
  email_id?: string | null;
};

export type CustomerIDs = {
  userId: string;
  email?: string | null;
};

export type MappedCustomerProperties = {
  is_freedom_client?: boolean;
  first_name?: string;
  email?: string;
  birth_date?: number;
  issubscribed?: boolean;
};

export type CustomerProperties = {
  firstName?: string;
  email?: string;
  birthDate?: string;
  isSubscribed?: boolean;
};

export type EventProperties = Record<
  bloomreachEventsConfig.BloomreachEventName,
  unknown & { language?: string }
>;

type StartFunction = (options?: Config) => void;

type IdentifyFunction = (
  customerIds: string | number | Record<string, unknown>,
  customerProperties?: CustomerProperties,
  successCallback?: () => void,
  errorCallback?: () => void,
  immediate?: boolean,
) => void;

type TrackFunction = (
  eventName: string,
  eventProperties?: Record<string, unknown>,
  successCallback?: () => void,
  errorCallback?: () => void,
) => void;

type UpdateFunction = (customerProperties: CustomerProperties) => void;

type AnonymizeFunction = () => void;

export interface ExponeaAPI {
  start: StartFunction;
  identify: IdentifyFunction;
  track: TrackFunction;
  update: UpdateFunction;
  anonymize: AnonymizeFunction;
}

/**
 * Banner placement identifiers for Bloomreach Web Layer targeting
 */
export enum BannerPlacement {
  MAIN = 'main',
  SERP_PAGE_OPEN = 'serp_page_open',
  BILL_PAID = 'bill_paid',
}
